import horizontal from '@lumlab/platform-brand/svg/lumlab-horizontal.svg';
import horizontalWhite from '@lumlab/platform-brand/svg/lumlab-horizontal-white.svg';
import stacked from '@lumlab/platform-brand/svg/lumlab.svg';
import stackedWhite from '@lumlab/platform-brand/svg/lumlab-white.svg';
import symbol from '@lumlab/platform-brand/svg/lumlab-icon.svg';
import { useTranslation } from 'react-i18next';

const files = {
    horizontal: [horizontal, horizontalWhite],
    stacked: [stacked, stackedWhite],
    symbol: [symbol, symbol],
} as const;

/** The LumLab logo of the shell: navy wordmark on the light theme, white wordmark on the dark theme. */
export function BrandLogo({
    layout = 'horizontal',
    className = '',
}: {
    layout?: keyof typeof files;
    className?: string;
}) {
    const { t } = useTranslation();
    const [light, dark] = files[layout];
    if (light === dark) return <img src={light} alt={t('platform.brand.name')} className={className} />;
    return (
        <>
            <img src={light} alt={t('platform.brand.name')} className={`dark:hidden ${className}`} />
            <img src={dark} alt={t('platform.brand.name')} className={`hidden dark:block ${className}`} />
        </>
    );
}
